export default __webpack_public_path__ + "static/media/laptop8.0e1ebb64.jpeg";